'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { EidrLogo } from '@/assets/EidrHeaderAssets';
import MainMenu from '@/components/MainMenu';

import UserProfile from '@/components/UserProfile';
import LoginModal from '@/components/LoginModal';
import { usePathname, useSearchParams } from 'next/navigation';
import SessionState from "@/lib/session-state";
import { autorun, toJS } from "mobx";


export default function EidrHeader() {

    const [user, setUser] = useState(null);
    const [isMounted, setIsMounted] = useState(false);

    const pathname = usePathname();
    const searchParams = useSearchParams();


    useEffect(() => {
        const currentUrl = pathname + searchParams.toString();
        // Your logic here, triggered by route change
        console.log('Route changed:', currentUrl);
        window._paq?.push(['setCustomUrl', currentUrl]);
        window._paq?.push(['setDocumentTitle', document.title]);
        window._paq?.push(['trackPageView']);
    }, [pathname, searchParams]);


    autorun(() => {
        if (SessionState.isLoggedIn === true && !user) {
            setUser(SessionState.user);
        } else if (SessionState.isLoggedIn === false && (user !== false)) {
            setUser(false);
        } else {
        }
    }
    )


    const UserSettings = ({ user }) => {
        if (user) {
            return <UserProfile user={user} />;
        } else if (SessionState.isLoggedIn === false) {
            return (
                <LoginModal></LoginModal>
            );
        } else {
            return <></>
        }
    };

    const toggleMobileMenu = () => {
        const root = document.documentElement;
        root.classList.add('menu-open');
    };

    return (
        <>
            <header className="main-header">
                <div className="container py-3 md:py-7">
                    <div className="flex justify-between items-center w-full">
                        <div className="lg:flex lg:grow-1 justify-between items-center">
                            <Link href="/">
                                <div className="header-logo">
                                    <EidrLogo />
                                </div>
                            </Link>
                            <h3 className="lg:pr-5 lg:text-2xl sm:text-base text-sm font-light text-white">
                                Entertainment Identifier Registry
                            </h3>
                        </div>
                        <div className="lg:shrink-0 flex items-center">
                            <UserSettings user={user} />
                            <button
                                type="button"
                                className="mobile-menu-button ms-2 flex items-center justify-center"
                                onClick={() => {
                                    toggleMobileMenu();
                                }}
                            >
                                <i className="mio" style={{ fontSize: '40px' }}>
                                    menu
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <MainMenu user={user} />
        </>
    );
}
